import { render } from "./DataUploadDialog.vue?vue&type=template&id=f1b8ebaa&ts=true"
import script from "./DataUploadDialog.vue?vue&type=script&lang=ts"
export * from "./DataUploadDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__